import React from 'react';
import { ConfigProvider } from 'antd';
import LogoGR from '../../assets/images/tmov-logo-branco.svg';
import riskManagementImage from '../../assets/images/login-risk-management.png';
import CorpoLogin from './CorpoLogin';
import EsqueciMinhaSenha from './EsqueciMinhaSenha';
import Cadastrese from './Cadastrar';
import WelcomeSuccess from './Welcome';
import * as S from './styles';

export function Login() {
  const [render, setRender] = React.useState('CorpoLogin');

  if (render === 'WelcomeSuccess' || render === 'Cadastrar') {
    return (
      <S.Wrapper>
        {render === 'Cadastrar' ? (
          <Cadastrese setRender={setRender} LogoGR={LogoGR} />
        ) : (
          <WelcomeSuccess setRender={setRender} LogoGR={LogoGR} />
        )}
      </S.Wrapper>
    );
  }

  return (
    <ConfigProvider theme={S.loginTheme}>
      <S.LayoutComp>
        <S.VisualPanel aria-label="Gerenciamento de risco">
          <S.HeroImage src={riskManagementImage} alt="" />
          <S.HeroContent>
            <S.Eyebrow>Inteligência em gerenciamento de risco</S.Eyebrow>
            <h2>Segurança em cada decisão.</h2>
            <p>
              Informação e controle para cuidar da sua operação, do início ao
              destino.
            </p>
          </S.HeroContent>
        </S.VisualPanel>
        <S.AccessPanel aria-label="Acesso TMOV GR">
          <S.AccessContent>
            <S.Brand>
              <S.Logo src={LogoGR} alt="logo tmovGr" width="322" height="67" />
            </S.Brand>
            {render === 'CorpoLogin' ? (
              <CorpoLogin
                onClickEsqueci={() => setRender('EsqueciMinhaSenha')}
                setRender={setRender}
              />
            ) : (
              <EsqueciMinhaSenha
                onClickVoltar={() => setRender('CorpoLogin')}
              />
            )}
            <S.AccessFooter>TMOV GR · Gerenciamento de risco</S.AccessFooter>
          </S.AccessContent>
        </S.AccessPanel>
      </S.LayoutComp>
    </ConfigProvider>
  );
}
